import { Button, Col, Form, FormInstance, Input, Modal, Row, Typography } from "antd";
import { useEffect, useState } from "react";
import FormLabel from "src/components/AntdCustomPart/FormLabel/FormLabel";
import ModalTitle from "src/components/AntdCustomPart/ModalTitle/ModalTitle";
import { SettingTankType } from "src/entity/settings/tank";
import { generateErrorMessage } from "src/utils/error-message";

const { Text } = Typography;

const TankTypeModal = (props: {
  form: FormInstance;
  open: boolean;
  loading: boolean;
  mode: "insert" | "update";
  isDuplicate: boolean;
  onDuplicateChange: (isDup: boolean) => void;
  onCloseModal: () => void;
  onSave: (mode: "insert" | "update", data: SettingTankType) => void;
}) => {
  const { form, open, mode, loading, isDuplicate, onDuplicateChange, onCloseModal, onSave } = props;
  const [errorDuplicate, setErrorDuplicate] = useState<string | null>(null);

  const handleSave = async () => {
    try {
      await form.validateFields();
      const formData = form.getFieldsValue();
      onSave(mode, formData);
    } catch (error) {
      // console.log("validate failed");
      console.error(error);
    }
  };

  const onChangeForm = (changeValue: any) => {
    if (["tankType", "description"].some((key) => changeValue[key])) {
      onDuplicateChange(false);
    }
  };

  useEffect(() => {
    const errorText = isDuplicate ? "Tank Type, Description already exists in the system." : "";
    setErrorDuplicate(errorText);
    form.setFields(
      ["tankType", "description"].map((field) => ({
        name: field,
        errors: isDuplicate ? [""] : [],
      })),
    );
  }, [isDuplicate]);

  return (
    <div>
      <Modal
        centered
        maskClosable={false}
        open={open}
        onCancel={onCloseModal}
        width={700}
        title={<ModalTitle title="Tank Type" />}
        footer={
          <Row className="w-full border-t" justify={"end"}>
            <Button className="mt-4" key="submit" type="primary" loading={loading} onClick={handleSave}>
              Save
            </Button>
          </Row>
        }
      >
        {errorDuplicate && (
          <>
            <Row className="w-full" justify={"center"}>
              <Text type="danger">{errorDuplicate}</Text>
            </Row>
          </>
        )}
        <Form size="middle" layout="vertical" autoComplete="off" form={form} requiredMark={false} onValuesChange={onChangeForm}>
          <Row gutter={[16, 0]}>
            <Col xs={24} sm={12} lg={12}>
              <Form.Item
                label={<FormLabel label={"Tank Type"} required />}
                name="tankType"
                rules={[{ required: true, message: generateErrorMessage("Tank Type") }]}
              >
                <Input />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12} lg={12}>
              <Form.Item
                label={<FormLabel label={"Description"} required />}
                name="description"
                rules={[{ required: true, message: generateErrorMessage("Description") }]}
              >
                <Input />
              </Form.Item>
            </Col>

            <Col xs={24}>
              <Form.Item label={<FormLabel label={"Remark"} />} name="remark">
                <Input.TextArea rows={3}></Input.TextArea>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </div>
  );
};

export default TankTypeModal;
